__turbopack_context__.v({
  "bigCard": "choose-module__ywnHYq__bigCard",
  "collapsed": "choose-module__ywnHYq__collapsed",
  "expanded": "choose-module__ywnHYq__expanded",
  "iconimg": "choose-module__ywnHYq__iconimg",
  "imgbox": "choose-module__ywnHYq__imgbox",
  "kicker": "choose-module__ywnHYq__kicker",
  "miniCard": "choose-module__ywnHYq__miniCard",
  "miniCardWrap": "choose-module__ywnHYq__miniCardWrap",
  "miniLeft": "choose-module__ywnHYq__miniLeft",
  "miniRight": "choose-module__ywnHYq__miniRight",
  "readmore": "choose-module__ywnHYq__readmore",
  "roadmapFirst": "choose-module__ywnHYq__roadmapFirst",
  "roadmapSecond": "choose-module__ywnHYq__roadmapSecond",
  "rowWrap": "choose-module__ywnHYq__rowWrap",
  "sectiontitle": "choose-module__ywnHYq__sectiontitle",
  "subtitle": "choose-module__ywnHYq__subtitle",
  "text-primary": "choose-module__ywnHYq__text-primary",
});
